/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import CampaignModel from 'cio/models/campaign';
import { Channel, Measure, Periods } from 'cio/utils/metrics/common';
import { DateRange } from '@customerio/fly-components/utils/fly-date-picker-utils';
import { Grouping } from 'cio/utils/metrics/resolution';
import {
  JourneyMetrics,
  MEASURE_COLORS,
  JOURNEY_MEASURE_DEFINITIONS,
  DATA_CAMPAIGN_JOURNEY_MEASURE_DEFINITIONS,
  MEASURE_LABELS,
} from 'cio/utils/journey-metrics';
import { inject as service } from '@ember/service';
import { Metric } from 'cio/utils/metrics/models/metric';
import AnalyticsService from 'cio/services/analytics';
import MetricsService from 'cio/services/metrics';
import SettingsService from 'cio/services/settings';

enum MetricsTab {
  Delivery = 'Delivery Metrics',
  Journey = 'Journey Metrics',
}

interface TabItem {
  icon: string;
  key: 'delivery' | 'journey';
  value: MetricsTab;
  hash: string;
}

interface JourneyDefinition {
  label: string;
  definition: string;
  color: Record<string, any>;
}

interface Args {
  containerOffsetStyle: string;

  campaign: CampaignModel;
  channelMetrics: Partial<Record<Channel, Metric>>;
  isLoadingDeliveryMetrics: boolean;
  actionDeliveryMetrics: Record<string, Metric>;

  timeRange: DateRange;
  timePeriod: Periods;
  grouping: Grouping;
  unit: 'count' | 'percentage';

  graphTab: 'delivery' | 'journey';
  onGraphTabChange: (tab: 'delivery' | 'journey') => unknown;

  deliveryChartType: 'individual' | 'aggregate';
  onDeliveryChartTypeChange: (type: 'individual' | 'aggregate') => unknown;
  deliveryChannel: Channel;
  onDeliveryChannelChange: (channel: Channel) => unknown;
  deliveryIndividualMeasure: Measure;
  onDeliveryIndividualMeasureChange: (measure: Measure) => unknown;
  deliveryMeasures: Measure[];
  onDeliveryMeasuresChange: (measures: Measure[]) => unknown;

  isLoadingJourneysMetrics: boolean;
  journeysMetrics: JourneyMetrics;
  journeysMeasures: Measure[];
  onJourneysMeasuresChange: (measures: Measure[]) => unknown;

  onTrackCopyLink: () => unknown;
}

export default class MetricsGraphCard extends Component<Args> {
  @service analytics!: AnalyticsService;
  @service metrics!: MetricsService;
  @service settings!: SettingsService;

  MetricsTab = MetricsTab;
  tabs: TabItem[] = [
    {
      key: 'delivery',
      icon: 'send-auto',
      value: MetricsTab.Delivery,
      hash: 'performance-delivery-tab',
    },
    {
      key: 'journey',
      icon: 'person',
      value: MetricsTab.Journey,
      hash: 'journeys-tab',
    },
  ];

  constructor(owner: unknown, args: Args) {
    super(owner, args);
  }

  get currentTab() {
    return this.tabs.find((t) => t.key === this.args.graphTab);
  }

  get journeyMetricsDefinitions(): JourneyDefinition[] {
    let journeyMeasureDefinitions = this.args.campaign.isDataCampaign
      ? DATA_CAMPAIGN_JOURNEY_MEASURE_DEFINITIONS
      : JOURNEY_MEASURE_DEFINITIONS;

    return Object.keys(journeyMeasureDefinitions).map((measure: string) => ({
      label: (MEASURE_LABELS as Record<string, string>)[measure],
      definition: (journeyMeasureDefinitions as Record<string, string>)[measure],
      color: MEASURE_COLORS[measure],
    }));
  }

  @action
  onTrackDefinitionTooltip() {
    this.analytics.track('campaign', 'journey_metrics_tooltip_viewed', {
      model: this.args.campaign,
    });
  }
}
